import React from 'react';
import ListItem from './ListItem';
import ShowHideRepliesLink from './ShowHideRepliesLink';

const ListItemReply = ListItem;
const List = ({ comments, loadMoreComments }) => (
  <div >
    {
      comments.map((comment, index) => (
        <ListItem
          author={comment.user.display_name}
          id={comment.id}
          avatar_url={comment.user.mini_thumbnail_url || '/images/profile.jpg'}
          replies={comment.replies}
          created_at={comment.created_at}
          comment_type={comment.comment_type}
          liked={comment.liked}
          disliked={comment.disliked}
          likes_count={comment.likes_count}
          dislikes_count={comment.dislikes_count}
          commented_id={comment.id}
          commented_type={comment.comment_type}
          page_number={comment.page_number}
          body={comment.body}
          userId={comment.user.id}
          key={index}
          can_reply={true}
          skin="t-pv2 t-ph2-ns bb bl br b--black-20"
          loadMoreComments={loadMoreComments}
          last={index === comments.length - 1}
          withSensor={index === comments.length - 5 || index === comments.length - 1}
        >
          { comment.pop_comment_replies_count > 0 &&
            <div className="a-replies t-mt2 t-pt2">
              <ShowHideRepliesLink comment={comment} />

              {
                comment.replies.map((reply, rIndex) => (
                  <ListItemReply
                    author={reply.user.display_name}
                    id={reply.id}
                    avatar_url={reply.user.avatar_url || '/images/profile.jpg'}
                    replies={[]}
                    created_at={reply.created_at}
                    comment_type={comment.comment_type}
                    liked={reply.liked}
                    disliked={reply.disliked}
                    likes_count={reply.likes_count}
                    dislikes_count={reply.dislikes_count}
                    commented_id={comment.id}
                    commented_type={comment.comment_type}
                    body={reply.body}
                    userId={reply.user.id}
                    last={false}
                    withSensor={false}
                    key={rIndex}
                    skin="t-pv2 t-mt1"
                    can_reply={false}
                  />
                ))
              }
            </div>
          }
        </ListItem>
      ))
    }
  </div>
);

List.defaultProps = {
  comments: [],
  loadMoreComments: null
};

export { List };
